module.exports = __webpack_public_path__ + "9500ed2d984d2a3872dcbe92c170771c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/DOW_LOGO_BG.png
// module id = 144
// module chunks = 0